import { APP_LOGIN_URL } from '@/config'

export function CTA() {
  return (
    <section className="py-24 bg-white">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="relative overflow-hidden rounded-3xl">
          {/* Gradient background */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, #08C6EA, #0798b8)' }} />

          {/* Content */}
          <div className="relative px-8 py-16 sm:px-16 sm:py-20 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Replace your paper ledger today
            </h2>
            <p className="text-lg text-white/90 max-w-2xl mx-auto mb-8">
              Join hundreds of Sri Lankan businesses already using Ledger to track income, manage credit, and grow with confidence.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={APP_LOGIN_URL}
                className="w-full sm:w-auto btn bg-white text-surface-900 hover:bg-surface-100 text-base px-8 py-3.5 font-semibold"
              >
                Start Free Trial
              </a>
              <a
                href="/pricing"
                className="w-full sm:w-auto btn bg-white/20 text-white hover:bg-white/30 border border-white/30 text-base px-8 py-3.5"
              >
                View Pricing
              </a>
            </div>

            <p className="mt-4 text-sm text-white/70">No credit card required · Cancel any time</p>
          </div>
        </div>
      </div>
    </section>
  )
}
